module.exports = __webpack_public_path__ + "img/Gift-Box-In-Hand.88ffdab6.png";